import {
  StrictLocalizeFunction,
  useStrictLocalization,
} from "@faire/web/common/localization";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { IRoutingContext } from "@faire/web/ui/routing/RoutingContext";
import { useMemo } from "react";

import { suppliersBrandValuePath } from "@faire/retailer/paths/suppliers/suppliersBrandValuePath";
import { useRetailerRoutingContext } from "@faire/retailer/RetailerRoutingContextProvider";
import { getSettingAllowedBrandTagDefinitions } from "@faire/retailer/settings/getSettingAllowedBrandTagDefinitions";

const BRAND_VALUES = (
  strictLocalize: StrictLocalizeFunction,
  routingContext: IRoutingContext
) => [
  {
    id: "WOMEN_OWNED",
    name: strictLocalize({
      defaultMessage: "Women owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/1bb1746876e68497e743ddaa9806c3a4bf9b152cc5023da2ca04ec028d61f734.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/7253458b1cde21d4c723066f9fc33b3b5bf15650e8befdf5604129e034b2f2d5.jpeg",
      name: "Flowerhead Tea",
      location: strictLocalize({
        defaultMessage: "Los Angeles, California",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/1bb1746876e68497e743ddaa9806c3a4bf9b152cc5023da2ca04ec028d61f734.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Our love of community, strong women, the beautiful California landscape, and sipping tea from around the world were all the driving inspirations for our brand. We believe tea is best shared with a loved one, a couple laughs, and maybe a few tears.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/1bb1746876e68497e743ddaa9806c3a4bf9b152cc5023da2ca04ec028d61f734.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop women owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/1bb1746876e68497e743ddaa9806c3a4bf9b152cc5023da2ca04ec028d61f734.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "women-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "AAPI_OWNED",
    name: strictLocalize({
      defaultMessage: "AAPI owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/4ce1ff308ddf02d65d0838ae743c9559e3fa3080237457515843c9a014b09ce4.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/3ca9c2e4e464acc9870e0db0df34e4c181f552d5f3015eeb749f1a2016d020db.jpeg",
      name: "Omsom",
      location: strictLocalize({
        defaultMessage: "Brooklyn, New York",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/4ce1ff308ddf02d65d0838ae743c9559e3fa3080237457515843c9a014b09ce4.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Started by Vietnamese-American sisters, Kim & Vanessa Pham, Omsom brings “proud + loud” Asian flavors to your home kitchen any day of the week. Our Saucy Noodles and Cooking Sauces are all crafted in partnership with Asian American chefs who share our mission to reclaim Asian American flavors too often diluted in the mainstream.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/4ce1ff308ddf02d65d0838ae743c9559e3fa3080237457515843c9a014b09ce4.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop AAPI owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/4ce1ff308ddf02d65d0838ae743c9559e3fa3080237457515843c9a014b09ce4.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "asian-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "BLACK_OWNED",
    name: strictLocalize({
      defaultMessage: "Black owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/dd059be7d87e4599c5e60ad2e7ccb494107fe055ea7e193844eb3042909ecfee.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/19461514dcb24eaa3212c59d391946ad319f459ca393174a7e74b1f6e33de0da.jpeg",
      name: "Homa Studios",
      location: strictLocalize({
        defaultMessage: "Newark, New Jersey",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/dd059be7d87e4599c5e60ad2e7ccb494107fe055ea7e193844eb3042909ecfee.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Join Altarik Banks, the visionary behind Homa Studios, on a journey of artistic innovation. Homa Studios gives the everyday an upgrade with home and dining objects that prize craftsmanship, emerging technology and collaboration. All objects are designed and produced in-house in our Newark, NJ design studio and small batch manufacturer.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/dd059be7d87e4599c5e60ad2e7ccb494107fe055ea7e193844eb3042909ecfee.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop black owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/dd059be7d87e4599c5e60ad2e7ccb494107fe055ea7e193844eb3042909ecfee.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "black-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "LATINO_OWNED",
    name: strictLocalize({
      defaultMessage: "Latino owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/0cdffe8f9c6dcc5d49bbd50abc3a896fc83d9660a470d02e87e030a71b8dbfc5.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/98d42243548175b7b768fbc50f22f6e43719f5c716644ea094c7a26d46f7453d.jpeg",
      name: "Jen Zeano Designs",
      location: strictLocalize({
        defaultMessage: "Brownsville, Texas",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/0cdffe8f9c6dcc5d49bbd50abc3a896fc83d9660a470d02e87e030a71b8dbfc5.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We're a lifestyle brand that builds community and celebrates cultura every day! JZD started in 2016 because we felt like we needed a reminder of our power. We focus on creating products that make us feel represented and connected to our roots.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/0cdffe8f9c6dcc5d49bbd50abc3a896fc83d9660a470d02e87e030a71b8dbfc5.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop Latino owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/0cdffe8f9c6dcc5d49bbd50abc3a896fc83d9660a470d02e87e030a71b8dbfc5.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "latino-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "LGBTQ_OWNED",
    name: strictLocalize({
      defaultMessage: "LGBTQI+ owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/b09ea79a42ec4f9480327b8ca71374eb5f620a8a69ca519846518bd69ab2b0e1.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/70f1f9fb4d2cc1301e62e2a841a4d9593ca6665a5a2854a2d1b8ce0b67aa3aab.jpeg",
      name: "MINNA",
      location: strictLocalize({
        defaultMessage: "Hudson, New York",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/b09ea79a42ec4f9480327b8ca71374eb5f620a8a69ca519846518bd69ab2b0e1.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We are a women and queer led business, which informs our approach to just about everything we do. We believe in creating beautiful, ethically made products and using business to do good. Our handcrafted heirloom textiles weave together traditional techniques with a contemporary aesthetic for thoughtful, timeless interiors rooted in responsible design.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/b09ea79a42ec4f9480327b8ca71374eb5f620a8a69ca519846518bd69ab2b0e1.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop LGBTQI+ owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/b09ea79a42ec4f9480327b8ca71374eb5f620a8a69ca519846518bd69ab2b0e1.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "lgbtq_owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "ECO_FRIENDLY",
    name: strictLocalize({
      defaultMessage: "Eco-friendly",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/ee4b3c365a60ef3ef96985dc557bc4ba6a2924341d89fa67bb6934baece4395c.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/fcb3ab46fe7b33a096d79e6a0bbcbdb8d4109b7c3f3bfcc5438dd22cc42c5d67.jpeg",
      name: "Bathing Culture",
      location: strictLocalize({
        defaultMessage: "San Francisco, California",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/ee4b3c365a60ef3ef96985dc557bc4ba6a2924341d89fa67bb6934baece4395c.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We package each product with care for its carbon impact, use, reuse, and end of life. The cornerstone of our approach is our refill program for Mind and Body Wash, which lets you refill your soap at over 200 stores nationwide.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/ee4b3c365a60ef3ef96985dc557bc4ba6a2924341d89fa67bb6934baece4395c.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop eco-friendly",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/ee4b3c365a60ef3ef96985dc557bc4ba6a2924341d89fa67bb6934baece4395c.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "eco-friendly",
          routingContext,
        }),
      },
    },
  },
  {
    id: "ORGANIC",
    name: strictLocalize({
      defaultMessage: "Organic",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/8d29702843cd92c242198e9104aa7ddd8258df985d679b5a17d3f107004d0a37.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/c152bd09126524a08fa2bd30e727b79d14ed4eb64d188fa35a8645265bc45181.jpeg",
      name: "Inners",
      location: strictLocalize({
        defaultMessage: "Paris, France",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/8d29702843cd92c242198e9104aa7ddd8258df985d679b5a17d3f107004d0a37.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We are convinced that health cannot be resolved by swallowing a simple pill, but by permanently changing our eating habits. This is why we have formulated adaptogen coffees and powdered supplements, natural and organic, that are easy to use in our drinks or in our food. Our mission? Decomplexify health by making it easy, tasty and accessible to as many people as possible.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/8d29702843cd92c242198e9104aa7ddd8258df985d679b5a17d3f107004d0a37.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop organic",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/8d29702843cd92c242198e9104aa7ddd8258df985d679b5a17d3f107004d0a37.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "organic",
          routingContext,
        }),
      },
    },
  },
  {
    id: "HANDMADE",
    name: strictLocalize({
      defaultMessage: "Handmade",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/a4521b578a0c3135dc8285f0e1ac9f38143d377013e276472a1cf4a3249533fe.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/254d7229f41f43695b521b8df2f362cf780b6327109cf38efd14bf3c3253c761.jpeg",
      name: "Zizia Botanicals",
      location: strictLocalize({
        defaultMessage: "Los Angeles, California",
        description: {
          text: "Brand value banner brand name",
          img: "https://cdn.faire.com/fastly/a4521b578a0c3135dc8285f0e1ac9f38143d377013e276472a1cf4a3249533fe.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Our herbalist-formulated clean skincare line is created in-house by Abbe, blending together her love of herbal medicine and science. From the subway to the 101, we make innovative formulas for everyday use.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/a4521b578a0c3135dc8285f0e1ac9f38143d377013e276472a1cf4a3249533fe.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop handmade",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/a4521b578a0c3135dc8285f0e1ac9f38143d377013e276472a1cf4a3249533fe.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "hand-made",
          routingContext,
        }),
      },
    },
  },
  {
    id: "NOT_SOLD_ON_AMAZON",
    name: strictLocalize({
      defaultMessage: "Not on Amazon",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/56ef582a1cca0c6d2ca18e5fdc76683f074c32d597aa60db2f1330beba84149a.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/97db8726b20e7cf5dbd5853adb2c5f7503b36279ff536d1496eb11db81d6e71e.jpeg",
      name: "Sightglass Coffee Roasters",
      location: strictLocalize({
        defaultMessage: "San Francisco, California",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/56ef582a1cca0c6d2ca18e5fdc76683f074c32d597aa60db2f1330beba84149a.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Knowing the story behind your coffee—where it was grown, how it was processed, who handled it along the way—is a powerful link from the cup to the wider world. We aim to deliver the highest quality, whether that’s sourcing the most beautiful and wondrous coffees or employing the most mindful and quality-focused practices possible.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/56ef582a1cca0c6d2ca18e5fdc76683f074c32d597aa60db2f1330beba84149a.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop not on Amazon",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/56ef582a1cca0c6d2ca18e5fdc76683f074c32d597aa60db2f1330beba84149a.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "not-sold-on-amazon",
          routingContext,
        }),
      },
    },
  },
  {
    id: "GIVES_BACK",
    name: strictLocalize({
      defaultMessage: "Gives back",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/bf57a91b9f8df87156127e0777b4e3db06836af554a104ed200ef47321cd0f21.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/85b28965592d4f9e79d258f5cf547953f374028661ff237f058d3892cf5cb8f4.jpeg",
      name: "Capra Designs",
      location: strictLocalize({
        defaultMessage: "Balnarring Beach, Australia",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/bf57a91b9f8df87156127e0777b4e3db06836af554a104ed200ef47321cd0f21.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“First inspired by nature, Capra Designs holds a commitment to operate thoughtfully through the practices, processes and materials that bring our designs to life. We are ever pursuing cleaner and lighter alternatives that are kinder on the planet. Capra Designs donates a portion of every sale via I=Change.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/bf57a91b9f8df87156127e0777b4e3db06836af554a104ed200ef47321cd0f21.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop gives back",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/bf57a91b9f8df87156127e0777b4e3db06836af554a104ed200ef47321cd0f21.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "gives-back",
          routingContext,
        }),
      },
    },
  },
  {
    id: "WOMEN_OWNED_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Women owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/7253458b1cde21d4c723066f9fc33b3b5bf15650e8befdf5604129e034b2f2d5.jpeg",
      name: "pretti.cool",
      location: strictLocalize({
        defaultMessage: "Houston, Texas",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Pretti.Cool was founded by a bunch of 90's kids who wanted an excuse to collaborate on making products that are both practical and fun.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop women owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/1bb1746876e68497e743ddaa9806c3a4bf9b152cc5023da2ca04ec028d61f734.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "women-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "AAPI_OWNED_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "AAPI owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/81cecadb6c62b4a5c8247c521b732d67edaab16f395669317c789f8a376aeb25.jpeg",
      name: "Fly By Jing",
      location: strictLocalize({
        defaultMessage: "Los Angeles, California",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Founded in 2018 by Jing Gao, a chef, entrepreneur and renowned expert on Chinese cuisine, we’re on a mission to evolve culture through taste and expand palates and minds.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop AAPI owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/4ce1ff308ddf02d65d0838ae743c9559e3fa3080237457515843c9a014b09ce4.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "asian-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "BLACK_OWNED_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Black owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/19461514dcb24eaa3212c59d391946ad319f459ca393174a7e74b1f6e33de0da.jpeg",
      name: "Hot N Saucy",
      location: strictLocalize({
        defaultMessage: "Powder Springs, Georgia",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Hot N Saucy is a proudly black-owned business making your classic hot sauce, reimagined. With vgetable based sauces curated in small batches by Chef Sam Davis-Allonce, our bright, bold and colorful sauces give you the heat you want and need at no additive cost. Yep, it’s all sauce and all natural.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop black owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/dd059be7d87e4599c5e60ad2e7ccb494107fe055ea7e193844eb3042909ecfee.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "black-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "LATINO_OWNED_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Latino owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/98d42243548175b7b768fbc50f22f6e43719f5c716644ea094c7a26d46f7453d.jpeg",
      name: "Masienda",
      location: strictLocalize({
        defaultMessage: "Santa Monica, California, United States",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“Masienda is collectively owned by our team, based across the US and Mexico. Representing distinct perspectives from throughout the masa foodway, we are proud to serve professional chefs and home cooks with the ingredients and tools needed to make the best masa-based dishes in their own kitchens. Bienvenidos.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop Latino owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/0cdffe8f9c6dcc5d49bbd50abc3a896fc83d9660a470d02e87e030a71b8dbfc5.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "latino-owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "LGBTQ_OWNED_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "LGBTQI+ owned",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/70f1f9fb4d2cc1301e62e2a841a4d9593ca6665a5a2854a2d1b8ce0b67aa3aab.jpeg",
      name: "Han's Kombucha by HK Brewing Collective",
      location: strictLocalize({
        defaultMessage: "Salt Lake City, Utah",
        description: {
          text: "brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "\"Born from the fierce spirit of women leaders and proudly queer-owned, we're here to shatter your preconceived notions about kombucha. Forget the bland and predictable—we're on a mission to redefine the probiotic beverage game. Join us in flipping the script on probiotic experiences!\"",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop LGBTQI+ owned",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/b09ea79a42ec4f9480327b8ca71374eb5f620a8a69ca519846518bd69ab2b0e1.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "lgbtq_owned",
          routingContext,
        }),
      },
    },
  },
  {
    id: "ECO_FRIENDLY_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Eco-friendly",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/fcb3ab46fe7b33a096d79e6a0bbcbdb8d4109b7c3f3bfcc5438dd22cc42c5d67.jpeg",
      name: "Juniper Ridge",
      location: strictLocalize({
        defaultMessage: "Oakland, California",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We use sustainably harvested plants and steam distillation to craft fragrance for home & body in Oakland, CA. By focusing on plants native to the West Coast, we bring the beauty of its natural splendor into your home. Juniper Ridge is paraben and sulfate-free, dye-free, petroleum product free, and cruelty-free–good for the whole person.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop eco-friendly",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/ee4b3c365a60ef3ef96985dc557bc4ba6a2924341d89fa67bb6934baece4395c.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "eco-friendly",
          routingContext,
        }),
      },
    },
  },
  {
    id: "ORGANIC_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Organic",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/c152bd09126524a08fa2bd30e727b79d14ed4eb64d188fa35a8645265bc45181.jpeg",
      name: "3rd Ritual",
      location: strictLocalize({
        defaultMessage: "Brooklyn, New York",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“3rd Ritual is a mindful collective founded by aromatherapist and meditation teacher Jenn Tardif. Everything we create—from botanical blends to limited edition home objects—is inspired by the belief that simple rituals lead to sacred experiences.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop organic",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/8d29702843cd92c242198e9104aa7ddd8258df985d679b5a17d3f107004d0a37.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "organic",
          routingContext,
        }),
      },
    },
  },
  {
    id: "HANDMADE_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Handmade",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/254d7229f41f43695b521b8df2f362cf780b6327109cf38efd14bf3c3253c761.jpeg",
      name: "VERLOOP | knits",
      location: strictLocalize({
        defaultMessage: "Denton, Maryland",
        description: {
          text: "Brand value banner brand name",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“VERLOOP is on a mission to reduce textile waste with playful, resourceful design. Made in a family-owned factory in the Philippines, VERLOOP knits repurpose deadstock material and bring feel-good color to everyday life.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop handmade",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/a4521b578a0c3135dc8285f0e1ac9f38143d377013e276472a1cf4a3249533fe.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "hand-made",
          routingContext,
        }),
      },
    },
  },
  {
    id: "NOT_SOLD_ON_AMAZON_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Not on Amazon",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/97db8726b20e7cf5dbd5853adb2c5f7503b36279ff536d1496eb11db81d6e71e.jpeg",
      name: "Potluck",
      location: strictLocalize({
        defaultMessage: "Boston, Massachusetts",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We're reimagining the classics and partnering with a network of skilled makers to do it. Potluck is bold flavors and no fillers—grounded in tradition but not bound by its rules. We’re meant for big nights, dinners-for-one, potlucks and pick-me-ups.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),

      cta: {
        name: strictLocalize({
          defaultMessage: "Shop not on Amazon",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/56ef582a1cca0c6d2ca18e5fdc76683f074c32d597aa60db2f1330beba84149a.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "not-sold-on-amazon",
          routingContext,
        }),
      },
    },
  },
  {
    id: "GIVES_BACK_FALL_BACK",
    name: strictLocalize({
      defaultMessage: "Gives back",
      description: {
        text: "Brand value banner tab name",
        img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
      },
    }),
    brand: {
      image:
        "https://cdn.faire.com/fastly/29de9648f2db72ff86ebcbbb6afa22097fb83322082877de6581cb52f695d8e3.jpeg",
      name: "Original Duckhead US",
      location: strictLocalize({
        defaultMessage: "London, United Kingdom",
        description: {
          text: "Brand value banner brand location",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      description: strictLocalize({
        defaultMessage:
          "“We're an umbrella company implementing innovative design technology to save post-consumer plastic waste from landfills and seas. We have recycled over 3 million post-consumer plastic bottles, and our mission is to recycle over 10 million plastic bottles by 2030. Our ultimate goal is to give back more than we take.”",
        description: {
          text: "Brand description",
          img: "https://cdn.faire.com/fastly/70d3ad80164840e9b607569e121d1ff628fbf844cc43116e81272db7c7eede22.png",
        },
      }),
      cta: {
        name: strictLocalize({
          defaultMessage: "Shop gives back",
          description: {
            text: "cta on brand value banner, goes to all brands category page",
            img: "https://cdn.faire.com/fastly/bf57a91b9f8df87156127e0777b4e3db06836af554a104ed200ef47321cd0f21.png",
          },
        }),
        link: suppliersBrandValuePath({
          urlIds: [{ id: "All Brands" }],
          brandValue: "gives-back",
          routingContext,
        }),
      },
    },
  },
];

export interface BrandInfo {
  image: string;
  name: string;
  location: string;
  description: string;
  cta: { name: string; link: string };
}

export const useGetBrandValues = (): {
  id: string;
  name: string;
  brand: BrandInfo;
}[] => {
  const { strictLocalize } = useStrictLocalization();
  const routingContext = useRetailerRoutingContext();
  return useMemo(() => {
    const allowedBrandValues = new Set(getSettingAllowedBrandTagDefinitions());
    const brandValues = BRAND_VALUES(strictLocalize, routingContext);
    return (
      brandValues
        .map((brandValue) =>
          allowedBrandValues.has(brandValue.id)
            ? {
                name: brandValue.name,
                brand: brandValue.brand,
                id: brandValue.id,
              }
            : undefined
        )
        .filter(isNotUndefined) ?? []
    );
  }, [routingContext, strictLocalize]);
};
